export const TYPES = {
  ADD_PRODUCTS: 'ADD_PRODUCTS',
  ADD_TO_CART: 'ADD_TO_CART',
  REMOVE_ITEM_CART: 'REMOVE_ITEM_CART',
  ADD_ONE_CART: 'ADD_ONE_CART',
  REMOVE_ONE_CART: 'REMOVE_ONE_CART',
  RESET_CART: 'RESET_CART',
  SINGLE_PURCHASE: 'SINGLE_PURCHASE'
}